import { Buffer } from "buffer";
import process from "process";

import React from "react";
import ReactDOM from "react-dom/client";
import store from "./services/store";
import { Provider } from "react-redux";
import "./index.css";
import App from "./components/app/App";
import { initI18n } from "./i18n";

window.Buffer = Buffer;
window.process = process;

const startApp = async () => {
  await initI18n();

  const RootApp = () => {
    return (
      <React.StrictMode>
        <Provider store={store} >
          <App />
        </Provider>
      </React.StrictMode>
    );
  };

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(<RootApp />);
};
startApp();
